var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfidentialityOuter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 66.0051,
    height: 76,
    viewBox: "0 0 66.0051 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62.0332 8.43069C58.1433 7.8274 54.3816 6.6208 50.5481 4.75419C47.9343 3.48056 45.4845 2.00068 42.8452 0.092815L42.717 0H23.2932L23.1651 0.0979714C20.3617 2.10896 17.7223 3.68166 14.8626 5.05326C11.0547 6.81674 7.3544 7.94599 3.56189 8.49773H3.53626L3.51064 8.50804C1.34275 9.07524 0 10.8336 0 13.0972L0.01025 38.1005C0.01025 45.5876 3.26464 53.5027 9.16353 60.3865C15.5749 67.8735 24.2157 73.5507 32.8667 75.9639L33 76L33.1332 75.9639C41.3025 73.7003 49.3386 68.6006 55.7602 61.6034C58.907 58.1744 61.3209 54.5701 63.1402 50.5945C65.057 46.4023 65.9897 42.1638 65.9949 37.6468L66.0051 13.3963C66.0051 10.6634 64.483 8.7607 62.0332 8.42554V8.43069ZM3.08014 13.0972C3.08014 12.2206 3.59776 11.607 4.44339 11.4936C8.12828 10.9264 11.7722 9.82292 15.5903 8.12131C18.5218 6.77034 21.2842 5.17701 24.2721 3.11446H41.733C44.7158 5.17701 47.4474 6.74971 50.3072 8.06459C54.1202 9.80745 57.8717 10.9367 61.7719 11.5245C62.5252 11.7617 62.9199 12.3083 62.9199 13.1024L62.9045 38.2604C62.8942 53.5285 47.4628 68.4098 33 72.7979C21.2381 69.1781 9.57866 58.8911 5.24289 48.2793C3.78739 44.7213 3.11089 41.5863 3.10576 38.4151L3.08526 13.1024L3.08014 13.0972Z",
    fill: "#94F608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfidentialityOuter);
export default __webpack_public_path__ + "static/media/icon-confidentiality-outer.05d482214227dbdd668726a509bda14f.svg";
export { ForwardRef as ReactComponent };